import React from "react";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

const CsvDownloadButton = ({data, filename}) => {

  const headers = Object.keys(data[0]);

  const downloadCSV = () => {
    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...data].map((row) => Object.values(row).join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <OverlayTrigger placement="bottom" overlay={ <Tooltip id="download-data">Download data in CSV file</Tooltip>}>
    <div className='icon-container'>
      <FileDownloadIcon className='switch-view' onClick={downloadCSV}/>
    </div>
    </OverlayTrigger>
  );
};

export default CsvDownloadButton;
